import React, { useMemo, useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Head from "next/head";
import Footer from "../../components/_App/Footer";
import Navbar from "../../components/_App/Navbar1";
import PageBanner from "../../components/Common/PageBanner";
import Pagination from "../../components/pagination";

// import { getAllPostIds } from '../../../../lib/posts'
let PageSize = 9;

const Blogs = ({ days, dataNav }) => {
  const router = useRouter();
  const [articles, setArticles] = useState(days);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const [tabUrl, setTabUrl] = useState(null);
  // const [totalResults, setTotalResults] = useState(days.data.pages);

  const totalResults = days.total;
  // const postPerPage = days.current_affairs.length;
  // console.log("posts per page:", totalResults);
  // let PageSize = Math.ceil(totalResults/postPerPage);
  // console.log("posts per page:", PageSize);

  // const loadNext = async () => {
  //   const { slug } = router.query;
  //   // const slug = days && days.paths[1].slug;
  //   // console.log("page:", page);
  //   const res = await fetch(
  //     `https://api.toppersnotes.com/api/ca/categories-wise-articles?category_slug=${slug}&per_page=9&page=${page + 1}&lang=en`
  //   );
  //   // window.scrollTo(0, 0);
  //   const days = await res.json();
  //   setPage(page + 1);
  //   // console.log("page:", page);
  //   setArticles(days);
  //   // setArticles((value) => [...value, ...days]);
  // };

  const loadPages = async () => {
    const { slug } = router.query;
    const res = await fetch(
      `https://api.toppersnotes.com/api/ca/categories-wise-articles?category_slug=${slug}&per_page=9&page=${currentPage}&lang=en`
    );

    // window.scrollTo({ top: 0, behavior: "smooth" });
    const days = await res.json();
    // setPage(page - 1);
    // console.log("page:", page);
    setArticles(days);
  };

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    loadPages();
  }, [currentPage]);

  useEffect(() => {
    setTabUrl(window.location.href);
  }, []);

  // console.log('days', days)
  return (
    <React.Fragment>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle={days && days.paths[1].name}
        homePageUrl="/"
        homePageText="Home"
        activePageText={
          days &&
          days.paths.map((path, index) => {
            const i = days.paths.length - 1;
            return (
              <>
                {index == 0 ? (
                  <Link href="/current-affairs">
                    <a>{path.name}</a>
                  </Link>
                ) : index == 1 ? (
                  <Link href="#">
                    <a>{path.name}</a>
                  </Link>
                ) : (
                  <Link href="#">
                    <a>{path.name}</a>
                  </Link>
                )}
                {index !== i && " / "}
              </>
            );
          })
        }
      />

      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <title>{days && days.category && days.category.name}</title>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta
            property="og:title"
            content={days && days.category && days.category.name}
            key="title"
          />
          <meta
            name="description"
            content={days && days.current_affairs && days.current_affairs.head}
          />
          <meta
            property="og:description"
            content={days && days.current_affairs && days.current_affairs.head}
            key="description"
          />
          <meta
            property="og:image"
            content={days && days.current_affairs && days.current_affairs.image}
            key="description"
          />
          <link
            rel="canonical"
            property="og:description"
            content={days && days.current_affairs && days.current_affairs.head}
            key="description"
            href={tabUrl}
          ></link>
        </Head>
      </div>

      <div className="blog-area ptb-100">
        <div className="container">
          <div className="row">
            {/* <div className="text-blue-600 font-bold h-8">Current Affairs</div> */}
            {articles &&
              articles.current_affairs &&
              articles.current_affairs.map((post, id) => {
                // {
                //   console.log("inner consloe", id, post);
                // }
                // image: post.image
                return (
                  <div className="col-lg-4 col-md-6">
                    <a href={`/current-affairs/blog/${post.slug}`}>
                      <div className="single-blog-post-box p-1 pt-2">
                        <div className="post-image relative h-64 aspect-w-1">
                          {/* href="/single-blog-1" */}
                          <Link href={`/current-affairs/blog/${post.slug}`}>
                            <a>
                              {/* <div>h-64 w-96</div> */}
                              <img
                                className="h-56 w-96 absolute object-fill"
                                src={post.image}
                                alt={post.head}
                              />
                              {/* <img src="/images/blog/blog1.jpg" alt="image" /> */}
                            </a>
                          </Link>
                        </div>
                        <div className="post-content">
                          {/* <Link href="#">
                        <a className="category">{post.tags[0].name}</a>
                      </Link> */}
                          <h3>
                            <Link href={`/current-affairs/blog/${post.slug}`}>
                              <a>
                                {post && post.head && post.head.length > 40 ? (
                                  <>{post.head.slice(0, 40)}...</>
                                ) : post.head.length < 25 ? (
                                  <>
                                    {post.head} <br />
                                    <br />
                                  </>
                                ) : (
                                  post.head
                                )}
                              </a>
                            </Link>
                          </h3>
                          <ul className="post-content-footer d-flex justify-content-between align-items-center">
                            <li>
                              <div className="post-author d-flex align-items-center">
                                <img
                                  src={post.author_image}
                                  className="rounded-circle"
                                  alt={post.author_name}
                                />
                                <span>{post.author_name}</span>
                              </div>
                              {/* <div className="post-author d-flex align-items-center">
                              <img
                                src="/images/user1.jpg"
                                className="rounded-circle"
                                alt="image"
                              />
                              <span>Alex Morgan</span>
                            </div> */}
                            </li>
                            <li>
                              <i className="flaticon-calendar"></i> {post.date}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </a>
                  </div>
                );
              })}
            <div className="inline-flex flex justify-center">
              <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                totalCount={totalResults}
                pageSize={PageSize}
                onPageChange={(page) => setCurrentPage(page)}
              />
              {/* <button disabled={page<=1}
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-l-md rounded-r-md disabled:opacity-50"
                onClick={loadPrevious}
              >
                Prev
              </button>
              <button disabled={totalResults <= page}
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-l-md rounded-r-md disabled:opacity-50"
                onClick={loadNext}
              >
                Next
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default Blogs;

export const getStaticPaths = async () => {
  // const res = await fetch(`https://api.toppersnotes.com/api/ca/categories`);
  // const offering = await res.json();
  // const paths = offering.map((offer) => ({
  //   params: { slug: offer.slug.toString() },
  // }));

  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async (context) => {
  const slug = context.params.slug;
  // const { params } = context;
  // const { slug } = params;
  // console.log("this params, and slug:", slug);
  const res = await fetch(
    `https://api.toppersnotes.com/api/ca/categories-wise-articles?category_slug=${slug}&per_page=9&page=1&lang=en`
  );

  const days = await res.json();
  //   console.log("getstatic props console for testing:", days);
  if (!days) {
    return {
      notFound: true,
    };
  }
  return {
    props: { days },
    revalidate: 86400,
  };
};
